import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import { themes } from '@/styles/themes';
import { themeVariant } from '@/composables/useThemeVariant';

Vue.use(Vuetify);

// The site always runs in dark mode: variants are switched by swapping these colors.
const { colors } = themes[themeVariant.value];

export default new Vuetify({
    theme: {
        options: {
            customProperties: true,
        },
        dark: true,
        themes: {
            light: colors,
            dark: colors,
        },
    },
});
